import {
  Bridge,
  Buildings,
  Garage,
  House,
  HouseLine,
  Lighthouse,
  Mountains,
  Park,
  SwimmingPool,
  Tent,
  TextAUnderline,
  Tipi,
  Warehouse,
} from "@phosphor-icons/react";
import { DeviceType } from "../../system/types/style/StyledComponentProps";

interface AccommodationIconProps {
  name: string;
  deviceType: DeviceType;
}

function AccommodationIconList({ name, deviceType }: AccommodationIconProps) {
  return (
    <>
      {name === "전체" ? (
        <TextAUnderline
          size={deviceType === "mobile" ? 30 : 40}
          weight="light"
        />
      ) : null}
      {name === "building" ? (
        <Buildings size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "tent" ? (
        <Tent size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "bridge" ? (
        <Bridge size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "warehouse" ? (
        <Warehouse size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "house" ? (
        <House size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "houseline" ? (
        <HouseLine size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "garage" ? (
        <Garage size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "lighthouse" ? (
        <Lighthouse size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "park" ? (
        <Park size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "mountains" ? (
        <Mountains size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "swimmingpool" ? (
        <SwimmingPool size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
      {name === "tipi" ? (
        <Tipi size={deviceType === "mobile" ? 30 : 40} weight="light" />
      ) : null}
    </>
  );
}

export default AccommodationIconList;
